import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AppConfirmDialogComponent } from '../../../common/components/app-confirm-dialog/app-confirm-dialog.component';
import { CustomTranslateModule } from '../../../shared/translations/custom-translate.module';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [AppConfirmDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
  ],
  exports: [
    AppConfirmDialogComponent,

  ]
})
export class AppConfirmDialogModule { }

